import type { SocialPlatform } from '@kit/artists';

/**
 * Maps a dynamic audition form-field key to a social platform, so the renderer
 * can upgrade a plain text field (e.g. the default `instagramUsername` /
 * `tiktokUsername` template fields) to the shared `SocialHandleInput`.
 *
 * Requires a `username` / `handle` suffix after the platform name so
 * value-bearing fields like `youtubeVideoUrl` or `instagramFollowers` are NOT
 * treated as handles. `x` maps from both `x*` and `twitter*` keys. Matches
 * camelCase, snake_case and kebab-case (`instagramUsername`, `instagram_handle`,
 * `x-username`).
 */
const PLATFORM_PATTERNS: Array<[SocialPlatform, RegExp]> = [
  ['instagram', /(?:^|[._-])instagram[._-]?(?:username|handle)$/i],
  ['tiktok', /(?:^|[._-])tiktok[._-]?(?:username|handle)$/i],
  ['facebook', /(?:^|[._-])facebook[._-]?(?:username|handle)$/i],
  ['youtube', /(?:^|[._-])youtube[._-]?(?:username|handle)$/i],
  ['vimeo', /(?:^|[._-])vimeo[._-]?(?:username|handle)$/i],
  ['pinterest', /(?:^|[._-])pinterest[._-]?(?:username|handle)$/i],
  ['snapchat', /(?:^|[._-])snapchat[._-]?(?:username|handle)$/i],
  ['x', /(?:^|[._-])(?:x|twitter)[._-]?(?:username|handle)$/i],
];

export function socialPlatformForFieldKey(
  key: string | undefined | null,
): SocialPlatform | null {
  if (!key) return null;
  for (const [platform, pattern] of PLATFORM_PATTERNS) {
    if (pattern.test(key)) return platform;
  }
  return null;
}
